/* DC motion (design refresh 2026): scroll reveals. Additive by design:
   nothing is ever hidden unless this script runs, tags elements, and adds
   html.dc-motion - so no-JS, old browsers and reduced-motion users always
   see fully visible content. CSS lives in custom.css.liquid (dc-motion block). */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* [container selector, item selector within (null = the container itself), stagger ms] */
  var GROUPS = [
    ['#MainContent .t4s-top-heading', null, 0],
    ['#MainContent .t4s_box_pr_grid.t4s-products', '.t4s-product', 70],
    ['[id$="__b33de351-3f0e-4874-b9a7-213ffbab7fa7"] .t4s-row', '.t4s-img-child img, .dc-temp-logo', 55],
    ['[id*="__165285781279b90886"]', '.testimonial-inner', 110],
    ['[id*="__3e02ac48-bc1b-4e70-8bcf-228ea81120e1"]', '.t4s-quote-wrap', 130],
    ['.dc-accreditations', '.dc-accred-cell, .dc-accred-half', 80],
    ['#MainContent .t4s-hero-image .t4s-content-position', '.t4s-bl-item.t4s-animation-none', 110],
    ['[id*="__1655029153bf2fa5e8"]', '.t4s-text-bl', 0],
    ['[id*="__custom_section_EnUDrJ"], [id*="__custom_section_4cKXqr"], [id*="__custom_section_HtdYEJ"], [id*="__custom_section_tV984j"], [id*="__custom_section_a4bKzG"], [id*="__custom_section_QN66jP"], [id*="__custom_section_hkAGjn"]', '.t4s-custom-col > .t4s-col-inner', 110],
    ['[id*="__shipping_zb9Cpe"]', '.t4s-shipping-item', 90],
    ['[id*="__16534641153c050906"]', '.t4s-quote-wrap', 0],
    ['[id*="__custom_section_wVawAT"]', '.t4s-btn-custom', 0]
  ];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('dc-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

  var tagged = [];
  GROUPS.forEach(function (g) {
    var containers = document.querySelectorAll(g[0]);
    Array.prototype.forEach.call(containers, function (container) {
      var items = g[1] ? container.querySelectorAll(g[1]) : [container];
      var i = 0;
      Array.prototype.forEach.call(items, function (el) {
        if (el.classList.contains('dc-r')) return;
        /* never tag hidden elements (display:none breakpoint twins etc.) -
           they would never intersect and would stay invisible if shown later */
        var r = el.getBoundingClientRect();
        if (!r.width && !r.height) return;
        el.classList.add('dc-r');
        if (g[2] && i) el.style.transitionDelay = Math.min(i * g[2], 420) + 'ms';
        tagged.push(el);
        i++;
      });
    });
  });
  if (!tagged.length) return;

  document.documentElement.classList.add('dc-motion');
  tagged.forEach(function (el) { io.observe(el); });
})();

/* DC header (2026 refresh, r42): smooth sticky hide/reveal with hysteresis.
   The theme's own engine (T4SThemeSP.Header in interactable.min.js) is
   load-order dependent on this build: on some navigations it never binds
   (verified dead on /en-us loads 2026-07-18 - header stayed transparent over
   content and hide-on-scroll never fired), on others it runs its per-pixel
   flip-flop. This controller drives the SAME classes the theme CSS +
   custom.css already style (html.is-header--stuck,
   section.shopify-section-header-hidden) and RE-ASSERTS its decision every
   scroll tick instead of caching DOM state - so it is the sole driver when
   the theme engine is dead and converges within a frame when both run. Runs under
   prefers-reduced-motion too (the states are functional, not decorative);
   the slide transition is CSS-gated to no-preference. */
(function () {
  'use strict';
  var section = document.querySelector('.t4s-section-header');
  if (!section) return;
  if (window.Shopify && window.Shopify.designMode) return; /* theme editor keeps the stock engine */
  var optsEl = section.querySelector('[data-header-options]');
  var opts = {};
  try { opts = JSON.parse(optsEl ? optsEl.getAttribute('data-header-options') : '{}'); } catch (e) {}
  if (!opts.isSticky) return;
  /* Neuter the theme's engine BEFORE it binds (this script is deferred; the
     theme's interactable.min.js is lazy-loaded much later and parses this
     attribute at module init): its reveal path re-hides the header and re-arms
     a 66ms timer on every up-scroll event, so continuous scrolling up never
     reveals - one of the r42 header bugs. With the attribute gone it reads
     isSticky undefined and stays inert; this controller is the sole driver. */
  optsEl.removeAttribute('data-header-options');
  var hideOnDown = opts.hideScroldown !== false;
  var html = document.documentElement;
  var DOWN_HIDE = 24; /* px of downward travel before hiding - kills jitter flicker */
  var UP_REVEAL = 8;  /* px of upward travel before revealing */
  var lastY = Math.max(0, window.scrollY);
  var acc = 0, ticking = false;
  var mode = lastY <= section.offsetHeight + 20 ? 'top' : 'shown';

  function setCls(el, cls, on) {
    if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
  }

  function apply() {
    setCls(html, 'is-header--stuck', mode !== 'top');
    setCls(section, 'shopify-section-header-hidden', mode === 'hidden');
  }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY); /* clamp iOS rubber-band */
    var dy = y - lastY;
    lastY = y;
    if (y <= section.offsetHeight + 20) {
      acc = 0; mode = 'top';
    } else if (!hideOnDown) {
      mode = 'shown';
    } else {
      /* accumulate same-direction travel, reset on direction change */
      acc = (dy > 0) === (acc > 0) ? acc + dy : dy;
      if (acc > DOWN_HIDE) mode = 'hidden';
      else if (-acc > UP_REVEAL || mode === 'top') mode = 'shown';
      /* else: hold last decisive mode through jitter */
    }
    apply();
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* ---------------------------------------------------------------------------
   Delivery frequency dropdown position (client request 2026-08-08).

   Recharge renders its frequency <select> inside its own app block, directly
   under the Subscribe / One-time buttons. The client wants it grouped with the
   order configuration instead: below the quantity stepper and above Add to cart.
   The two live in different DOM subtrees (widget block vs product form), so CSS
   ordering cannot reach across them and the node has to be relocated.

   Notes:
   - Only the real dropdown is moved. On a product with a single plan Recharge
     renders .rc-selling-plans without a <select>, and custom.css.liquid prints a
     "Monthly Delivery" caption on it; that case is left exactly where it is.
   - The widget is a Vue app: it destroys the node when One-time is selected and
     recreates it on Subscribe, which is what makes the dropdown subscription-only.
     Recreation puts it back in the widget, so a MutationObserver re-places it.
     The select keeps its own listeners (moving a node preserves them), and the
     value posted to the cart is a separate hidden selling_plan input inside the
     form, which is untouched by any of this.
--------------------------------------------------------------------------- */
(function () {
  var ROW = 'form.t4s-form__product .t4s-product-form__buttons .t4s-d-flex';

  function place() {
    var row = document.querySelector(ROW);
    if (!row) return;
    var atc = row.querySelector('button[name="add"]');
    var src = document.querySelector('.rc-selling-plans');
    var isDropdown = src && src.querySelector('select');

    if (!isDropdown) {
      row.classList.remove('dc-has-plan-select');
      return;
    }
    if (!atc) return;

    /* Set the class on every pass, not just when a move happens: Vue sometimes
       recreates the node already in position, and an early return here would
       leave the row without the wrap override. */
    row.classList.add('dc-has-plan-select');
    if (src.parentElement === row && src.nextElementSibling === atc) return;

    row.insertBefore(src, atc);
  }

  function init() {
    place();
    var scope = document.querySelector('.t4s-product__info-container');
    if (!scope) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; place(); });
    }).observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
